module.exports = __webpack_public_path__ + "static/ss.9e63733c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/adrianmanduc/ss.png
// module id = 1157
// module chunks = 277036769636407